import { defineMessages } from 'react-intl';

export default defineMessages({
    tncLabel: {
        id: 'tdic.autopay.component.By checking this box, I agree to the Terms of Use including the Billing and Payments section and have kept a copy of this authorization for my records.',
        defaultMessage: 'By checking this box, I agree to the {link} including the Billing and Payments section and have kept a copy of this authorization for my records.\nI understand and agree that monthly invoices will be sent as electronic-only documents.'
    },
    autoPay: {
        id: 'tdic.autopay.component.Enroll in Autopay',
        defaultMessage: 'Enroll in Autopay'
    },
    paymentPlan: {
        id: 'tdic.autopay.component.Payment Plan',
        defaultMessage: 'Payment Plan'
    },
    monthlyAutoPay: {
        id: 'tdic.autopay.component.Monthly Autopay',
        defaultMessage: 'Monthly Autopay'
    },
    paymentSchedule: {
        id: 'tdic.autopay.component.Payment Schedule',
        defaultMessage: 'Payment Schedule'
    },
    startingDate: {
        id: 'tdic.autopay.component.Starting Date',
        defaultMessage: 'Starting Date'
    },
    source: {
        id: 'tdic.autopay.component.Source',
        defaultMessage: 'Source'
    },
    accountType: {
        id: 'tdic.autopay.component.Account Type',
        defaultMessage: 'Account Type'
    },
    accountNumber: {
        id: 'tdic.autopay.component.Account Number',
        defaultMessage: 'Account Number'
    },
    routingNumber: {
        id: 'tdic.autopay.component.Routing (ABA) Number',
        defaultMessage: 'Routing (ABA) Number'
    },
    bankName: {
        id: 'tdic.autopay.component.Bank Name',
        defaultMessage: 'Bank Name'
    },
    enrollInAutoPay: {
        id: 'tdic.autopay.component.Enroll in Autopay',
        defaultMessage: 'Enroll in Autopay'
    },
    cancel: {
        id: 'tdic.autopay.component.Cancel',
        defaultMessage: 'Cancel'
    },
    submit: {
        id: 'tdic.autopay.component.Setup Automatic Payment',
        defaultMessage: 'Setup Automatic Payment'
    },
    ok: {
        id: 'tdic.autopay.component.Ok',
        defaultMessage: 'Ok'
    },
    successmessage: {
        id: 'tdic.autopay.component.Success',
        defaultMessage: 'Thank you for enrolling in Autopay. Your payment method for policy {policyNumber} has been successfully updated to Monthly Autopay.Your new payment plan will be reflected on your monthly invoice each 1st of the month. Withdrawals from your bank account will be on or about the 20th of each month. To save paper, monthly invoices will be sent as electronic-only documents.'
    },
    failureMessage: {
        id: 'tdic.autopay.component.failure',
        defaultMessage: 'Sorry, we were not able to setup automatic payments on your account'
    },
    printAuthorization: {
        id: 'tdic.autopay.component.Print Authorization',
        defaultMessage: 'Print Authorization'
    },
    invalidEmail: {
        id: 'tdic.autopay.component.invalidEmail',
        defaultMessage: 'Please enter a valid email address.'
    },
    emailRequired: {
        id: 'tdic.autopay.component.emailRequired',
        defaultMessage: 'Email address is required.'
    }
});
